export const aliases = [
  {
    initialFieldName: 'Browse Url',
    positive: 'Has Browsed Url',
    negative: 'Has Not Browsed Url'
  },
  {
    initialFieldName: 'Browse Count',
    positive: 'Has Browsed',
    negative: 'Has Not Browsed'
  },
  {
    initialFieldName: 'Browsed Brand',
    positive: 'Has Browsed Brand',
    negative: 'Has Not Browsed Brand'
  },
  {
    initialFieldName: 'Browsed Category',
    positive: 'Has Browsed Category',
    negative: 'Has Not Browsed Category'
  },
  {
    initialFieldName: 'Browsed Subcategory',
    positive: 'Has Browsed Subcategory',
    negative: 'Has Not Browsed Subcategory'
  },
  {
    initialFieldName: 'Cart Has Brand',
    positive: 'Cart Has Brand',
    negative: 'Cart Does Not Have Brand'
  },
  {
    initialFieldName: 'Cart Has Category',
    positive: 'Cart Has Category',
    negative: 'Cart Does Not Have Category'
  },
  {
    initialFieldName: 'Cart Has Sku',
    positive: 'Cart Has Sku',
    negative: 'Cart Does Not Have Sku'
  },
  {
    initialFieldName: 'Cart Has Subcategory',
    positive: 'Cart Has Subcategory',
    negative: 'Cart Does Not Have Subcategory'
  },
  {
    initialFieldName: 'Cart Items On Sale',
    positive: 'Has Cart Items On Sale',
    negative: 'Has No Cart Items On Sale'
  },
  {
    initialFieldName: 'Area Code',
    positive: 'Area Code Is',
    negative: 'Area Code Is Not'
  },
  {
    initialFieldName: 'Email Domain',
    positive: 'Email Domain Is',
    negative: 'Email Domain Is Not'
  },
  {
    initialFieldName: 'Customer Tags',
    positive: 'Customer Has Tag',
    negative: 'Customer Does Not Have Tag'
  },
  {
    initialFieldName: 'Order Tags',
    positive: 'Order Has Tag',
    negative: 'Order Does Not Have Tag'
  },
  {
    initialFieldName: 'Order Item Clearance',
    positive: 'Has Ordered Clearance Item',
    negative: 'Has Not Ordered Clearance Item'
  },
  {
    initialFieldName: 'Order Item Discontinued',
    positive: 'Has Ordered Discontinued Item',
    negative: 'Has Not Orderd Discontinued Item'
  },
  {
    initialFieldName: 'Order Item On Sale',
    positive: 'Has Ordered On Sale Item',
    negative: 'Has Not Ordered On Sale Item'
  },
  {
    initialFieldName: 'Product Tags',
    positive: 'Product Has Tag',
    negative: 'Product Does Not Have Tag'
  },
  {
    initialFieldName: 'Subscription Status',
    positive: 'Is Subscribed',
    negative: 'Is Not Subscribed'
  },
  {
    initialFieldName: 'Clicked',
    positive: 'Has Clicked',
    negative: 'Has Not Clicked'
  },
  {
    initialFieldName: 'Opened',
    positive: 'Has Opened',
    negative: 'Has Not Opened'
  },
  {
    initialFieldName: 'Sent',
    positive: 'Was Sent',
    negative: 'Was Not Sent'
  },
  {
    initialFieldName: 'Product Tag',
    positive: 'Has Product Tag',
    negative: 'Does Not Have Product Tag'
  },
];